import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper,
  Button, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions
} from '@mui/material';
import { UploadFile, Delete, Visibility } from '@mui/icons-material';
import axios from 'axios';

const AdminEvents = () => {
  const token = localStorage.getItem('token');
  const [events, setEvents] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventImages, setEventImages] = useState([]);
  const [newImages, setNewImages] = useState([]);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios.get(`${API_BASE}/api/events?includeDrafts=true`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => setEvents(res.data));
  }, [API_BASE, token]);

  const handleViewImages = async (event) => {
    setSelectedEvent(event);
    const res = await axios.get(`${API_BASE}/api/admin/events/${event.id}/images`);
    setEventImages(res.data);
    setNewImages([]);
    setDialogOpen(true);
  };

  const handleUpload = async () => {
    if (!selectedEvent || newImages.length === 0) return;

    const formData = new FormData();
    newImages.forEach(file => formData.append('images', file));

    await axios.post(`${API_BASE}/api/admin/events/${selectedEvent.id}/upload-images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    const res = await axios.get(`${API_BASE}/api/admin/events/${selectedEvent.id}/images`);
    setEventImages(res.data);
    setNewImages([]);
  };

  const handleDeleteImage = async (imageId) => {
    if (!selectedEvent) return;
    if (!window.confirm('Delete this image?')) return;

    await axios.delete(`${API_BASE}/api/admin/events/${selectedEvent.id}/images/${imageId}`);
    setEventImages(prev => prev.filter(img => img.id !== imageId));
  };

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        Admin: Event Image Manager
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Description</strong></TableCell>
              <TableCell><strong>Event Date</strong></TableCell>
              <TableCell><strong>Venue</strong></TableCell>
              <TableCell><strong>Start Time</strong></TableCell>
              <TableCell><strong>End Time</strong></TableCell>
              <TableCell align="center"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <TableRow key={event.id}>
                <TableCell>{event.description}</TableCell>
                <TableCell>{new Date(event.eventDate).toISOString().split('T')[0]}</TableCell>
                <TableCell>{event.venue}</TableCell>
                <TableCell>{event.startTime}</TableCell>
                <TableCell>{event.endTime}</TableCell>
                <TableCell align="center">
                  <Button
                    startIcon={<Visibility />}
                    variant="outlined"
                    size="small"
                    onClick={() => handleViewImages(event)}
                  >
                    View Images
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          Manage Images for: {selectedEvent?.description}
        </DialogTitle>
        <DialogContent>
          <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
            {eventImages.map((img, i) => (
              <Box key={i} position="relative" width={100} height={100}>
                <img
                  src={`${API_BASE}/api/admin/events/images/${img.id}`}
                  alt={`img-${i}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: 4,
                    border: '1px solid #ccc'
                  }}
                />
                <IconButton
                  size="small"
                  onClick={() => handleDeleteImage(img.id)}
                  style={{
                    position: 'absolute',
                    top: -8,
                    right: -8,
                    backgroundColor: 'white',
                    boxShadow: '0 0 2px rgba(0,0,0,0.4)'
                  }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>

          <Box mt={2}>
            <Typography variant="subtitle1">Upload New Images:</Typography>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={(e) => setNewImages([...e.target.files])}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
          <Button
            onClick={handleUpload}
            variant="contained"
            startIcon={<UploadFile />}
            disabled={newImages.length === 0}
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminEvents;
